import memoize from 'lodash/memoize';

import sanitizeFacultyMember from 'sanitizers/sanitizeFacultyMember';

import { FacultyMember } from 'types';

export default memoize((facultyMembers: unknown[]): FacultyMember[] => {
  return facultyMembers.map(sanitizeFacultyMember);
});
